exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".noActivityBlock .noActivityHeader{border-bottom:1px solid #ddd;display:inline-block}.noActivityBlock .studentDisplay{margin-bottom:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/data/no_activity_block.scss
// module id = 1309
// module chunks = 0